/**
 * 미니맵 축척 — 메인 에디터·PL/SQL 편집기·실행계획 보기가 **같은 축척**으로 그린다 (2026-10-05).
 *
 * 예전엔 한 줄의 높이를 「미니맵 높이 ÷ 줄 수」로 늘려 채웠다. 그러면 줄 수에 따라 모양이 달라져
 * (35줄은 한 줄 12px 의 굵은 막대, 64줄은 6px) 같은 미니맵이 창마다 다르게 보였다.
 * 이제 한 줄은 최대 MINIMAP_LINE_PX 이고, 문서가 길어 다 안 들어갈 때만 높이에 맞춰 줄인다(VS Code 와 같다).
 * 그리기와 클릭·끌기가 **같은 함수**를 써야 위치 상자와 이동이 어긋나지 않는다.
 */
export const MINIMAP_LINE_PX = 3;

/** 한 줄의 높이(px) */
export function minimapLineHeight(height, lineCount) {
  if (!lineCount || lineCount <= 0 || !height || height <= 0) return MINIMAP_LINE_PX;
  return Math.min(MINIMAP_LINE_PX, height / lineCount);
}

/** 그려진 줄 전체의 높이(px) — 위치 상자와 클릭 위치를 이 범위 안에서 계산한다 */
export function minimapContentHeight(height, lineCount) {
  return minimapLineHeight(height, lineCount) * Math.max(0, lineCount || 0);
}

/** 위치 상자 { top, height } — scrollTop·scrollHeight·clientHeight 는 실제 스크롤 영역의 값 */
export function minimapViewport({ height, lineCount, scrollTop, scrollHeight, clientHeight }) {
  const content = minimapContentHeight(height, lineCount);
  if (!scrollHeight || scrollHeight <= 0 || content <= 0) return null;
  const top = (scrollTop / scrollHeight) * content;
  const h = Math.max(8, (clientHeight / scrollHeight) * content);
  return { top, height: h };
}

/**
 * 미니맵 위 y(캔버스 기준 px)를 눌렀을 때 옮겨 갈 scrollTop — 누른 자리가 화면 가운데에 오게.
 * 그려진 범위 아래 빈 곳을 누르면 맨 끝이다.
 */
export function minimapScrollTarget({ y, height, lineCount, scrollHeight, clientHeight }) {
  const content = minimapContentHeight(height, lineCount);
  const ratio = content > 0 ? Math.min(1, Math.max(0, y / content)) : 0;
  return Math.max(0, ratio * scrollHeight - clientHeight / 2);
}
